import axios from "axios";
import { formatApiError } from "@/admin/api";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;

export const USER_TOKEN_KEY = "ceogpt_user_token";

export const userApi = axios.create({ baseURL: API, timeout: 20000 });

userApi.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(USER_TOKEN_KEY);
    if (t) {
        cfg.headers = cfg.headers || {};
        cfg.headers.Authorization = `Bearer ${t}`;
    }
    return cfg;
});

userApi.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            const url = err?.config?.url || "";
            const isLoginCall = url.endsWith("/user/login") || url.endsWith("/auth/portal-login");
            if (!isLoginCall) {
                localStorage.removeItem(USER_TOKEN_KEY);
                if (
                    typeof window !== "undefined" &&
                    !window.location.pathname.startsWith("/login")
                ) {
                    window.location.assign("/login");
                }
            }
        }
        return Promise.reject(err);
    },
);

export { formatApiError };

/** Map role → dashboard route */
export const ROLE_TO_PATH = {
    ceo: "/app/ceo",
    sales: "/app/sales",
    finance: "/app/finance",
    hr: "/app/hr",
    operations: "/app/operations",
    marketing: "/app/marketing",
    customer: "/app/customer-support",
    procurement: "/app/procurement",
    legal: "/app/legal",
    strategy: "/app/strategy",
    meeting: "/app/meeting-admin",
    // Admin roles are directed to their own portals
    company_admin: "/company-admin/dashboard",
    platform_admin: "/admin",
};

export function pathForRole(role) {
    if (!role) return null;
    return ROLE_TO_PATH[role] || null;
}
